module.exports = __webpack_public_path__ + "static/img/logo.d5ffccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 6
// module chunks = 0